export default "__VITE_ASSET__66a778f2__"